module.exports = __webpack_public_path__ + "static/media/14.296ba37f.jpg";